import React, { useEffect, useCallback, useState } from "react";
import axios from "axios";
import style from "css/realtime.module.css";
import { Button, ConfigProvider, Empty, Modal, Table } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

function CmsEndpointModal(props) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);

    const audioColums = [
        { title: "Audio", key: "index", dataIndex: "index", width: "auto" },
        { title: "In", key: "In", dataIndex: "In", width: "25%" },
        { title: "Out", key: "Out", dataIndex: "Out", width: "25%" },
    ];
    const videoColums = [
        { title: "Video", key: "index", dataIndex: "index", width: "auto" },
        { title: "In", key: "In", dataIndex: "In", width: "25%" },
        { title: "Out", key: "Out", dataIndex: "Out", width: "25%" },
    ];

    const [audioData, setAudioDatas] = useState([]);
    const [videoData, setVideoDatas] = useState([]);

    const getCallLegDetail = useCallback(() => {
        setLoading(true);

        const param = {
            params: {
                callLegId: props.id
            },
        };

        axios.get("/active/callLegDetail", param)
            .then((res) => {
                if (res.status === 200) {
                    const audioData = res.data.audio;
                    const audioRows = [
                        {
                            key: "bitRate",
                            index: "bitRate",
                            In: audioData.in.bitRate,
                            Out: audioData.out.bitRate
                        },
                        {
                            key: "codec",
                            index: "codec",
                            In: audioData.in.codec,
                            Out: audioData.out.codec
                        },
                        {
                            key: "codecBitRate",
                            index: "codecBitRate",
                            In: audioData.in.codecBitRate,
                            Out: audioData.out.codecBitRate
                        },
                        {
                            key: "jitter",
                            index: "jitter",
                            In: audioData.in.jitter,
                            Out: audioData.out.jitter
                        },
                        {
                            key: "packetLossPercentage",
                            index: "packetLossPercentage",
                            In: audioData.in.packetLossPercentage,
                            Out: audioData.out.packetLossPercentage
                        },
                        {
                            key: "roundTripTime",
                            index: "roundTripTime",
                            In: audioData.in.roundTripTime,
                            Out: audioData.out.roundTripTime
                        },
                    ]

                    const videoData = res.data.video;
                    const videoRows = [
                        {
                            key: "Resolution",
                            index: "Resolution",
                            In: videoData.in.Resolution,
                            Out: videoData.out.Resolution
                        },
                        {
                            key: "bitRate",
                            index: "bitRate",
                            In: videoData.in.bitRate,
                            Out: videoData.out.bitRate
                        },
                        {
                            key: "codec",
                            index: "codec",
                            In: videoData.in.codec,
                            Out: videoData.out.codec
                        },
                        {
                            key: "frameRate",
                            index: "frameRate",
                            In: videoData.in.frameRate,
                            Out: videoData.out.frameRate
                        },
                        {
                            key: "jitter",
                            index: "jitter",
                            In: videoData.in.jitter,
                            Out: videoData.out.jitter
                        },
                        {
                            key: "packetLossPercentage",
                            index: "packetLossPercentage",
                            In: videoData.in.packetLossPercentage,
                            Out: videoData.out.packetLossPercentage
                        },
                        {
                            key: "roundTripTime",
                            index: "roundTripTime",
                            In: videoData.in.roundTripTime,
                            Out: videoData.out.roundTripTime
                        },
                    ]
                    setAudioDatas(audioRows);
                    setVideoDatas(videoRows);
                }
            })
            .finally(() => {
                setLoading(false);
            })
    }, [props.id]);

    useEffect(() => {
        if (props.open && props.id !== "") {
            getCallLegDetail();
        } else {
            setAudioDatas([]);
            setVideoDatas([]);
        }
    }, [getCallLegDetail, props]);

    return (
        <Modal
            centered
            title={t("LABEL.TITLE.DEVICE_DETAILS")}
            open={props.open}
            onCancel={props.close}
            footer={null}
        >
            <div className={style.endpointModal}>
                <Table
                    loading={loading}
                    rowKey="uid"
                    size="small"
                    columns={audioColums}
                    dataSource={audioData}
                    pagination={false}
                    locale={{ emptyText: <Empty description={t("MESSAGE.NO_DATA")} /> }}
                />
                <Table
                    loading={loading}
                    rowKey="uid"
                    size="small"
                    columns={videoColums}
                    dataSource={videoData}
                    pagination={false}
                    locale={{ emptyText: <Empty description={t("MESSAGE.NO_DATA")} /> }}
                />

                <div className={style.endpointModal_btn}>
                    <ConfigProvider
                        theme={{
                            token: {
                                fontFamily: "Spoqa Han Sans Neo",
                            },
                            components: {
                                Button: {
                                    colorPrimary: "#1677ff",
                                    colorPrimaryHover: "#50c1a1",
                                    colorPrimaryActive: "#50c1a1",
                                },
                            },
                        }}
                    >
                        <Button
                            size="small"
                            icon={<ReloadOutlined />}
                            onClick={getCallLegDetail}
                        />
                    </ConfigProvider>
                </div>
            </div>
        </Modal>
    );
}

export default CmsEndpointModal
